module.exports = __webpack_public_path__ + "media/application/images/icons/plus-6fb872df17ca1e5f30b9a40269d871f4.svg";